var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera_outer"},[_c('video',{staticStyle:{"margin":"0 auto"},attrs:{"id":"videoCamera","width":_vm.videoWidth,"height":_vm.videoHeight,"autoplay":""}}),_c('canvas',{staticStyle:{"display":"none"},attrs:{"id":"canvasCamera","width":_vm.videoWidth,"height":_vm.videoHeight}})])
}
var staticRenderFns = []

export { render, staticRenderFns }